import apiClient from "../apiClient";
import React from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const CurrenciesAdd = () => {
    const [currency, setCurrency] = useState({
        Description: "",
        IsDefault: 0,
        ExchangeRateToDefault: "1.000000",
        });

    const [error, setError] = useState(false)

    const navigate = useNavigate();

    const handleChange = (e) => {
        const value = e.target.type === "checkbox" ? (e.target.checked ? 1 : 0) : e.target.value;
        setCurrency((prev) => {
            const next = { ...prev, [e.target.name]: value };
            if (e.target.name === "IsDefault" && value) {
                next.ExchangeRateToDefault = "1.000000";
            }
            return next;
        });
        }

    const handleClick = async(e) => {
        e.preventDefault();
        if (!currency.Description?.trim()) return setError(true);
        try {
            await apiClient.post("/currencies", currency);
            navigate("/Currencies");
        } catch (err) {
            console.log(err);
            setError(true)
        }
     };
    
    return (
        <div className="page">
            <header className="page-header">
                <div>
                    <h1 className="page-title">Add Currency</h1>
                    <p className="page-subtitle"><Link to="/">Home</Link> / <Link to="/Currencies">Currencies</Link> / Add</p>
                </div>
            </header>
            <section className="panel form-card">
                <div className="form">
                    <label htmlFor="currency-description">Currency Description</label>
                    <input
                        id="currency-description"
                        type="text"
                        placeholder="e.g. USD"
                        name="Description"
                        value={currency.Description}
                        onChange={handleChange}
                    />
                    <label htmlFor="currency-is-default">Default Currency</label>
                    <input
                        id="currency-is-default"
                        type="checkbox"
                        name="IsDefault"
                        checked={Boolean(currency.IsDefault)}
                        onChange={handleChange}
                    />
                    <label htmlFor="currency-exchange-rate">Exchange Rate To Default Currency</label>
                    <input
                        id="currency-exchange-rate"
                        type="number"
                        step="0.000001"
                        min="0.000001"
                        name="ExchangeRateToDefault"
                        value={currency.ExchangeRateToDefault}
                        onChange={handleChange}
                        disabled={Boolean(currency.IsDefault)}
                    />
                    <div className="form-actions">
                        <button className="btn" onClick={handleClick}>Add Currency</button>
                        <Link className="btn-link" to="/Currencies">Cancel</Link>
                    </div>
                    {error && <p className="notice notice-error">Could not save currency. Check input and try again.</p>}
                </div>
            </section>
        </div>
         );
    };

export default CurrenciesAdd;
